export enum ProctorEnum {
    clientID = "osQFCwgd",
    clientSecret = "PgaiDPDJQZ8CXpr",
}